// import React, { useEffect, useState, useContext } from 'react';
// import './OverallShares.css';
// import axios from 'axios';
// import { FilterContext } from '../../components/pages/FilterContext'; // Import FilterContext
// import Filters from './Filters';
// import config from '../../config';
// import { useNavigate } from 'react-router-dom';

// const SecondView = () => {
//     const { selectedFilters, DisplayFiltersName } = useContext(FilterContext);
//     const [tableData, setTableData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('All'); // Default to "All"
//     const [selectedTab, setSelectedTab] = useState('All'); // Track selected tab (Debit/Credit)
//     const [selectedPaymentMethodBrandSharesData, setSelectedPaymentMethodBrandSharesData] = useState('All'); // Default to "All"
//     const [brandSharesData, setBrandSharesData] = useState([]); // Holds table data
//     const [dataSummary, setDataSummary] = useState(null); // Data summary state
//     const [apiCalled, setApiCalled] = useState(false);


//     const navigate = useNavigate();

//     useEffect(() => {
//         if (selectedFilters && Object.keys(selectedFilters).length > 0) {
//             const filteredFilters = Object.fromEntries(
//               Object.entries(selectedFilters).filter(([key, value]) => Array.isArray(value) && value.length > 0)
//           );
//           if (Object.keys(filteredFilters).length > 0) {
//             setLoading(true);
//             setApiCalled(false);
//             setTableData([]);
//             axios
//                 .post(`${config.API_BASE_URL}/api/second-view`, filteredFilters)
//                 .then((response) => {
//                     // console.log("response", response);
//                     const sortedData = response.data.sort((a, b) => {
//                         if (a.payment_method.includes('Base')) return -1;
//                         if (b.payment_method.includes('Base')) return 1;
//                         if (a.payment_method === 'Other') return 1;  // "Other" goes to the end
//                         if (b.payment_method === 'Other') return -1; // "Other" goes to the end
//                         return 0; // Keep the rest in the same order
//                     });
//                     setTableData(sortedData || []);
//                     setApiCalled(true);
//                     setLoading(false);
//                 })
//                 .catch((err) => {
//                     console.error('Error fetching table data:', err);
//                     setError('Failed to load data.');
//                     setApiCalled(true);
//                     setLoading(false);
//                 });
//         } }else {
//             // Handle the case when there are no selected filters
//             setLoading(false);
//             setTableData([]);
//             setApiCalled(false);
//         }
//     }, [selectedFilters]);

//     useEffect(() => {
//         if (selectedFilters && Object.keys(selectedFilters).length > 0) {
//         // Filter the selectedFilters to remove empty arrays
//         const filteredFilters = Object.fromEntries(
//             Object.entries(selectedFilters).filter(([key, value]) => 
//                 Array.isArray(value) && value.length > 0
//             )
//         );

//         if (Object.keys(filteredFilters).length > 0) {
//             // Pass the filtered filters as where_clause for filtering
//             const whereClause = JSON.stringify(filteredFilters);

//             fetch(`${config.API_BASE_URL}/api/data-summary`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({
//                     where_clause: whereClause, // Pass filtered filters as the where_clause
//                 }),
//             })
//                 .then((response) => response.json())
//                 .then((data) => {
//                     setDataSummary(data);
//                     setLoading(false);
//                 })
//                 .catch((error) => {
//                     console.error('Error fetching data summary:', error);
//                     setError('Failed to fetch data summary');
//                     setLoading(false);
//                 });
//         }} else {
//             setDataSummary([]);
//         }
//     }, [selectedFilters]);


//     // Helper function to clean payment method names
//     const cleanPaymentMethodName = (name) => {
//         return name
//             .replace(/_/g, ' ')
//             .replace(/%-|%/g, '')
//             .replace(/-Total$/, '')
//             .replace(/ - Debit$/, '')
//             .replace(/ - Credit$/, '')
//             .replace(/ - interac e-transfer$/, '')
//             .replace(/ReloadablePrePaid/, 'Reloadable/Pre-Paid');
//     };

//     // Filter payment methods based on selected tab
//     const filteredTableData = tableData.filter(item => {
//         if (selectedTab === 'Debit' && !/Debit_\w+/.test(item.payment_method)) {
//             return item.payment_method.includes('Debit');
//         }
//         if (selectedTab === 'Credit' && !/Credit\s.*/.test(item.payment_method)) {
//             return item.payment_method.includes('Credit');
//         }
//         return true; // For 'All' option
//     });
//     // Extract unique payment methods for the filtered data
//     // Extract and clean unique payment methods
//     const paymentMethods = [
//         ...new Set(
//             filteredTableData
//                 .map((item) => item.payment_method)
//                 .filter((method) => !/(Debit_|Credit_)/.test(method)) // Exclude 'Debit_' or 'Credit_'
//         ),
//     ];

//     // Extract unique years
//     // Extract unique years and sort them in descending order
//     const years = [...new Set(filteredTableData.map((item) => item.trans_year))].sort((a, b) => b - a);


//     // Structure table data for the filtered data
//     const structuredTableData = years.map((year) => ({
//         year,
//         data: paymentMethods.map((method) => {
//             const entry = filteredTableData.find(
//                 (item) => item.trans_year === year && item.payment_method === method
//             );
//             return entry ? entry.percentage : 0;
//         }),
//     }));

//     const goBack = () => {
//         navigate('/dashboards');
//     };


//     const renderSelectedFilters = () => {
//         let renderedTransYear = false; // Flag to track if 'trans_year' has been rendered
//         const subCategoryValues = []; // To accumulate sub-category values
//         const renderContent = [];

//         // Loop through the filter names and render them
//         Object.keys(DisplayFiltersName).map((displayName) => {
//           const filterKey = DisplayFiltersName[displayName]; // Get the object for the current display name

//           // If the filterKey is an array (like 'trans_year' or any other arrays), handle them
//           if (Array.isArray(filterKey)) {
//             // If it's 'trans_year' and has not been rendered, render it
//             if (displayName === "trans_year" && !renderedTransYear) {
//               renderedTransYear = true;
//               renderContent.push(
//                 <span key={displayName} className="selected-filter">
//                   <strong>Year: </strong>{filterKey.join(", ")}
//                 </span>
//               );
//             }
//             return; // Skip further handling for arrays (no need to process this again)
//           }

//           // Get the keys from the filterKey object (like user_age, user_gender)
//           const filterKeys = Object.keys(filterKey);

//           // Loop through each filter key (like user_age, user_gender)
//           filterKeys.map((key) => {
//             const filterValues = selectedFilters[key];

//             // Skip rendering if filterValues is empty or undefined
//             if (!filterValues || (Array.isArray(filterValues) && filterValues.length === 0)) {
//               return null;
//             }

//             // Skip rendering 'trans_year' if it's already been rendered
//             if (key === "trans_year" && renderedTransYear) {
//               return; // Skip if 'trans_year' has already been rendered
//             }

//             // Special handling for sub-categories
//             if (displayName === "Sub-Categories" || key.startsWith("SubCat_")) {
//               if (Array.isArray(filterValues)) {
//                 subCategoryValues.push(...filterValues); // Collect sub-category values
//               } else {
//                 subCategoryValues.push(filterValues);
//               }
//               return null; // Skip rendering immediately
//             }

//             // For other filters, display the regular displayName
//             const displayKey = key === "trans_year" ? "Year" : displayName;
//             const displayValues = Array.isArray(filterValues) ? filterValues.join(", ") : filterValues;

//             renderContent.push(
//               <span key={key} className="selected-filter">
//                 <strong>{displayKey}: </strong>{displayValues}
//               </span>
//             );
//           });
//         });

//         // Render the combined sub-categories at the end, only if they exist
//         if (subCategoryValues.length > 0) {
//           renderContent.push(
//             <span key="sub-categories" className="selected-filter">
//               <strong>Sub-Categories: </strong>{subCategoryValues.join(", ")}
//             </span>
//           );
//         }

//         return renderContent;
//       };



//     return (
//         <div className="container">
//             <Filters pageSpecificFilters="payment" />
//             <div className="table-section">
//                 <button onClick={goBack} className="back-button">
//                     &#8592;  Back
//                 </button>
//                 {/* Render selected filters before FilterTabs */}
//                 <div className="selected-filters-display">
//                     {renderSelectedFilters()}
//                 </div>
//                 <div>
//                     <table>
//                         <thead>
//                             <tr>
//                                 <th className="total-transac">
//                                     <u>Total Transactions</u>
//                                     <br />
//                                     <label className="label">
//                                         <i>
//                                             <strong>Base:</strong>  {dataSummary?.trans?.toLocaleString()}{/* Replace with actual data summary if needed */}
//                                         </i>
//                                     </label>
//                                 </th>
//                                 <th className="share-column">Share of Transactions</th>
//                             </tr>
//                         </thead>
//                     </table>
//                 </div>

//                 {loading ? (
//                     <div className="loader-container">
//                         <div className="loader"></div>
//                     </div>
//                 ) : error ? (
//                     <p className="error">{error}</p>
//                 ) : (!loading && apiCalled && tableData.length === 0 && Object.keys(selectedFilters).length > 0 && !error) ? (
//                     <p className="no-data">No data available for the selected filters.</p>
//                 ) : tableData.length > 0 ? (
//                     <div className="tablesview">
//                         <table>
//                             <thead>
//                                 <tr>
//                                     <th>Payment Methods</th>
//                                     {years.map((year) => (
//                                         <th key={year}>{year}</th>
//                                     ))}
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {paymentMethods.map((method) => {
//                                     const isBaseRow = method.includes('Base');
//                                     const isTotal = method.includes('Total');
//                                     return (
//                                         <tr
//                                             key={method}
//                                             className={`${isTotal
//                                                 ? 'blue-row'
//                                                 : (method.includes('Debit') || method.includes('Credit') || method.includes('interac e-transfer')) &&
//                                                     (method.includes('InPerson') || method.includes('Virtual'))
//                                                     ? 'special-row'
//                                                     : (method.includes('Using app or browser') || method.includes('Phone-tap') || method.includes('Website on mobile device') || method.includes('Website on browser')) &&
//                                                         (method.includes('Debit') || method.includes('Credit'))
//                                                         ? 'sub-special-row'
//                                                         : (method.includes('Debit') || method.includes('Credit') || method.includes('interac e-transfer'))
//                                                             ? 'gray-row'
//                                                             : ''
//                                                 } ${isBaseRow ? 'base-row' : ''}`}
//                                         >
//                                             {/* Update this column to show the special text for Base */}
//                                             <td>
//                                                 {isBaseRow ? <i>Base: Weighed number of transactions</i> : cleanPaymentMethodName(method)}
//                                             </td>
//                                             {structuredTableData.map((row) => {
//                                                 const value = row.data[paymentMethods.indexOf(method)];
//                                                 const isBase = method === "Base"; // Check if the payment method is "Base"

//                                                 return (
//                                                     <td key={row.year}>
//                                                         {value != null && !isNaN(value)
//                                                             ? isBase
//                                                                 ? <i>{`${value.toLocaleString()}`}</i> // No percentage formatting for "Base"
//                                                                 : `${value.toFixed(1)}%` // Percentage formatting for other methods
//                                                             : "N/A"}
//                                                     </td>
//                                                 );
//                                             })}
//                                         </tr>
//                                     );
//                                 })}
//                             </tbody>
//                         </table>
//                     </div>
//                 ) : null}
//             </div>
//         </div>
//     );
// };

// export default SecondView;
import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './OverallShares.css';
import axios from 'axios';
import { FilterContext } from '../../components/pages/FilterContext';
import Filters from './Filters';
import config from '../../config';

const SecondView = () => {
  const { selectedFilters, DisplayFiltersName } = useContext(FilterContext);
  const [brands, setBrands] = useState([]);
  const [data, setData] = useState([]);
  const [waves, setWaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [apiCalled, setApiCalled] = useState(false);
  const navigate = useNavigate();
  const [baseValue, setBaseValue] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);


  useEffect(() => {
    if (selectedFilters && Object.keys(selectedFilters).length > 0) {
      const filteredFilters = Object.fromEntries(
        Object.entries(selectedFilters).filter(([key, value]) => Array.isArray(value) && value.length > 0)
      );

      if (Object.keys(filteredFilters).length > 0) {
        setLoading(true);
        setApiCalled(false);

        axios
          .post(`${config.API_BASE_URL}/api/Overallshares`, {
            selectedFilters,
            groupId: 2,
          })
          .then((response) => {
            const { Brands, Data, Waves } = response.data;
            setBrands(response.data.Brands || []);
            setData(response.data.Data || []);
            setWaves(response.data.Waves || []);
            if (response.data.Data?.length > 0) {
              const seenWindex = new Set();
              let totalBase = 0;

              for (let i = 0; i < response.data.Data.length; i++) {
                const item = response.data.Data[i];
                if (!seenWindex.has(item.windex)) {
                  totalBase += item.Base || 0;
                  seenWindex.add(item.windex);
                }
              }
              const roundedBase = Math.round(totalBase);
              setBaseValue(roundedBase.toLocaleString());
            }
            // console.log('Brands:', Brands);
            // console.log('Data:', Data);
            // console.log('Waves:', Waves);
            setApiCalled(true);
            setLoading(false);
          })
          .catch((err) => {
            console.error('Error fetching data:', err);
            setError('Failed to load data.');
            setApiCalled(true);
            setLoading(false);
          });
      }
    } else {
      setLoading(false);
      setData([]);
      setApiCalled(false);
    }
  }, [selectedFilters]);


  const goBack = () => navigate('/dashboards');

  const renderSelectedFilters = () => {
    let renderedTransYear = false; // Flag to track if 'trans_year' has been rendered
    const subCategoryValues = []; // To accumulate sub-category values
    const renderContent = [];
    const brandValues = [];

    // Loop through the filter names and render them
    Object.keys(DisplayFiltersName).map((displayName) => {
      const filterKey = DisplayFiltersName[displayName]; // Get the object for the current display name

      // If the filterKey is an array (like 'trans_year' or any other arrays), handle them
      if (Array.isArray(filterKey)) {
        // If it's 'trans_year' and has not been rendered, render it
        if (displayName === "trans_year" && !renderedTransYear) {
          renderedTransYear = true;
          renderContent.push(
            <span key={displayName} className="selected-filter">
              <strong>Year: </strong>{filterKey.join(", ")}
            </span>
          );
        }
        return; // Skip further handling for arrays (no need to process this again)
      }

      // Get the keys from the filterKey object (like user_age, user_gender)
      const filterKeys = Object.keys(filterKey);

      // Loop through each filter key (like user_age, user_gender)
      filterKeys.map((key) => {
        const filterValues = selectedFilters[key];

        // Skip rendering if filterValues is empty or undefined
        if (!filterValues || (Array.isArray(filterValues) && filterValues.length === 0)) {
          return null;
        }

        // Skip rendering 'trans_year' if it's already been rendered
        if (key === "trans_year" && renderedTransYear) {
          return; // Skip if 'trans_year' has already been rendered
        }

        // ✅ Handle Sub-Categories
        if (displayName === "Sub-Categories" || key.startsWith("SubCat_")) {
          if (Array.isArray(filterValues)) {
            subCategoryValues.push(...filterValues);
          } else {
            subCategoryValues.push(filterValues);
          }
          return null;
        }

        // ✅ Handle Brand
        if (displayName === "Brand" || key.startsWith("Brand_")) {
          if (Array.isArray(filterValues)) {
            brandValues.push(...filterValues);
          } else {
            brandValues.push(filterValues);
          }
          return null;
        }

        // For other filters, display the regular displayName
        const displayKey = key === "trans_year" ? "Year" : displayName;
        const displayValues = Array.isArray(filterValues) ? filterValues.join(", ") : filterValues;

        renderContent.push(
          <span key={key} className="selected-filter">
            <strong>{displayKey}: </strong>{displayValues}
          </span>
        );
      });
    });

    // ✅ Render Sub-Categories
    if (subCategoryValues.length > 0) {
      renderContent.push(
        <span key="sub-categories" className="selected-filter">
          <strong>Sub-Categories: </strong>{subCategoryValues.join(", ")}
        </span>
      );
    }

    // ✅ Render Brand
    if (brandValues.length > 0) {
      renderContent.push(
        <span key="brand" className="selected-filter">
          <strong>Brand: </strong>{brandValues.join(", ")}
        </span>
      );
    }

    return renderContent;
  };

  const downloadTableData = async (selectedFilters) => {
    if (!data || !data.length) {
      alert("No data available to download.");
      return;
    }
    setIsDownloading(true); // show popup

    try {
      const kpi = "Total Shares by Form Factor & In-Person vs. Virtual"
      const response = await axios.post(
        `${config.API_BASE_URL}/download-data`,  // Replace with your actual API endpoint
        {
          selectedFilters: selectedFilters,
          Kpi: kpi,
          groupId: 2
        },
        { responseType: 'blob' } // Ensures file download
      );

      // Create a download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', kpi + '.xlsx'); // Change file name/format if needed
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading data:", error);
      alert("Failed to download data. Please try again.");
    } finally {
      setIsDownloading(false); // hide popup
    }
  };

  useEffect(() => {
    if (isDownloading) {
      document.body.classList.add('download-active');
    } else {
      document.body.classList.remove('download-active');
    }
  }, [isDownloading]);


  return (
    <div className="container">
      <Filters pageSpecificFilters="payment" />
      <div className="table-section">
        <div style={{ justifyContent: 'space-between', display: 'flex' }}>
          <button onClick={goBack} className="back-button">← Back</button>
          <button
            onClick={() => downloadTableData(selectedFilters)}
            className={`download-button ${!data?.length ? 'disabled' : ''}`}
            disabled={!data?.length}
          >
            <i className="fa fa-download"></i>&nbsp;
            <span className="download-text">Download Data</span>
          </button>
        </div>

        <div className="selected-filters-display">
          {renderSelectedFilters()}
        </div>

        {loading && (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        )}

        {error && <div className="error">{error}</div>}

        {!loading && apiCalled && (
          <div>
            {data.length === 0 ? (
              <div className="no-data-message">
                No data to display for selected filter.
              </div>
            ) : (
              <div className="scrollable-table">
                <table>
                  <thead>
                    <tr>
                      <th className="total-transac">
                        <u>Total Transactions</u>
                        <br />
                        <label className="label">
                          <i><strong>Base:</strong> {baseValue}</i>
                        </label>
                      </th>
                      <th className="share-column" colSpan={waves.length}>Share of Transactions</th>
                    </tr>
                    <tr>
                      <th>Payment Methods</th>
                      {waves.map((wave) => (
                        <th key={wave.Id}>{wave.Name}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="base-row">
                      <td><strong><i>Base: Weighed number of transactions</i></strong></td>
                      {waves.map((wave) => {
                        const value = data.find(d => d.windex === wave.Index);
                        return (
                          <td key={`base-${wave.Id}`}>
                            {value && value.Base !== undefined ? Math.round(value.Base).toLocaleString() : '-'}
                          </td>
                        );
                      })}
                    </tr>
                    {brands.map((brand) => (
                      <tr key={brand.Id} style={{ backgroundColor: `${brand.Color}`, textIndent: `${brand.Operator}` }}>
                        <td>{brand.Name}</td>
                        {waves.map((wave) => {
                          const value = data.find(d => d.bindex === brand.Index && d.windex === wave.Index);
                          return (
                            <td key={`${brand.Id}-${wave.Id}`}>
                              {value && value.Perc !== undefined && parseFloat(value.Perc) > 0
                                ? `${(Math.round(parseFloat(value.Perc) * 10) / 10).toFixed(1)}%`
                                : '-'}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

      </div>
      {isDownloading && (
        <div className="download-popup">
          <div className="popup-content">
            <div className="spinner"></div>
            <p>Preparing your download...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SecondView;
